import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { Link } from "react-router-dom";
import { AiOutlineArrowRight, AiOutlineDownload } from "react-icons/ai";
import { useLanguage } from "../../context/LanguageContext";

function Home() {
  const { t } = useLanguage();

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center hero-row">
            <Col lg={7} className="home-header">
              <div className="availability-pill">
                <span /> {t("hero.available")}
              </div>
              <p className="hero-kicker">{t("hero.intro")}</p>
              <h1 className="heading-name">
                {t("hero.title")}
                <strong className="main-name"> {t("hero.emphasis")}</strong>
              </h1>
              <div className="type-line">
                <span>{t("hero.focus")}</span>
                <Type />
              </div>
              <p className="hero-summary">{t("hero.summary")}</p>
              <div className="hero-actions">
                <Link to="/project" className="primary-action">
                  {t("hero.work")} <AiOutlineArrowRight />
                </Link>
                <Link to="/resume" className="secondary-action">
                  <AiOutlineDownload /> {t("hero.resume")}
                </Link>
              </div>
              <div className="hero-proof">
                <div><strong>9+</strong><span>{t("hero.years")}</span></div>
                <div><strong>15+</strong><span>{t("hero.projects")}</span></div>
                <div><strong>03</strong><span>{t("hero.platforms")}</span></div>
              </div>
            </Col>

            <Col lg={5} className="hero-visual">
              <div className="visual-orbit orbit-one">Flutter</div>
              <div className="visual-orbit orbit-two">Android</div>
              <div className="hero-image-shell">
                <span className="image-index">{t("hero.engineer")}</span>
                <img src={homeLogo} alt="Developer working at a desk" className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
